import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getStoreIncomeExpense } from "../../../services/IncomeExpense/IncomeExpense";
import { formatDateNewWithTime, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { getBrandCashBook } from "../../../services/Cashbook/Cashbook";
import AdminMenu from "../../AdminMenu";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import { Dropdown } from "primereact/dropdown";
import StoreIncomeExpenseCreateModal from "../../SettingComponent/StoreIncomeExpense/StoreIncomeExpenseCreateModal";
import StoreIncomeExpenseCreateModalAdmin from "../../SettingComponent/StoreIncomeExpense/StoreIncomeExpenseCreateModalAdmin";
import SchedularModal from "../../SchedularModal";

const StoreWiseIncomeExpense = () => {
  const navigate = useNavigate();
  const [storeIncomeData, setStoreIncomeData] = useState({});
  const [storeExpenseData, setStoreExpenseData] = useState({});
  const [selectedUserItemValue, setSelectedUserItemValue] = useState(null);

  const [visible, setVisible] = useState(false);
  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  

  const { brandProfileData, storeData, userProfileData, userProfileRole } =
    getUserData();
    const { storeLocalData } = getStoreLocalData();
  let brandId = brandProfileData.id;
  const userRole = userProfileRole;
  let storeId = storeData.id;
  const storeUserId = userProfileData.id;
  const [loading, setLoading] = useState(false);

  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

  const [storeList, setStoreList] = useState([]);
  const [storeValue, setStoreValue] = useState("");
  const [cashbookBalanceData, setCashbookBalanceData] = useState("");
  const [searchTermType, setSearchTermType] = useState(false);

    let initialStartDate = new Date();
    initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date
  
    // If orderFilterData is available, use its start and end dates
    const [startDate, setStartDate] = useState(new Date(initialStartDate));
    let initialEndDate = new Date();
    const [endDate, setEndDate] = useState(new Date(initialEndDate));
  
  const [
      storeIncomeExpenseCreateModalVisible,
      setStoreIncomeExpenseCreateModalVisible,
    ] = useState(false);
  

  const fetchStoreIncomeExpense = (IncomeExpenseData) => {
    setLoading(true);
    getStoreIncomeExpense(IncomeExpenseData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const ResIncome = response.data.incomeLogs;
          const ResExpense = response.data.expenseLogs;
          setStoreIncomeData(ResIncome);
          setStoreExpenseData(ResExpense);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchCashBook = (data) => {
    setLoading(true);
    getBrandCashBook(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCashbookBalanceData(Number(Number(Res.storeList[0].cashbookBalance)?.toFixed(enabledAmountRoundOffAdmin)));
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreData = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeData = response.data.map((item) => ({
            name: item.storeName,
            value: item.id, // store.id
          }));
          setStoreList(storeData);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

   const fetchFranchiseStore = async () => {
          const franchiseStore = await getLocalFranchiseStore();
          if (franchiseStore.franchiseStore !== null) {
            const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
            const storeData = Res.map((item) => ({
              name: item.storeName,
              value: item.id, // store.id
            }));
            setStoreList(storeData);
          } else {
            setStoreList([]); 
          }
        };

        
          const IncomeExpenseData = {
            brandId: brandId,
            storeIds: [storeValue],
          };
        
          const [requestData, setRequestData] = useState(IncomeExpenseData);
        

  useEffect(() => {
     if (userRole === "BY_FRANCHISE_ADMIN") {
       fetchFranchiseStore();
     } else {
       fetchStoreData();
     }
  }, []);

  const handleStoreChange = (item) => {
    setStoreValue(item);
    const data = {
      brandId: brandId,
      storeIds: [item],
      sortBy: "id",
      sortOrder: "desc",
    };
    fetchCashBook(data);
    const IncomeExpenseData = {
      brandId: brandId,
      storeIds: [item],
    };
    fetchStoreIncomeExpense(IncomeExpenseData);
  };

   const receiveDataFromStoreIncomeExpenseCreateModal = ({ success }) => {
     if (success) {
       const IncomeExpenseData = {
         brandId: brandId,
         storeIds: [storeValue],
       };
       fetchStoreIncomeExpense(IncomeExpenseData);
       const data = {
         brandId: brandId,
         storeIds: [storeValue],
         sortBy: "id",
         sortOrder: "desc",
       };
       fetchCashBook(data);
       setSelectedUserItemValue(null);
     }
   };

   const handleCalendarModal = () => {
       setSchedularModalVisible(true);
     };
   
     const [useEffectCall, setUseEffectCall] = useState(false);
     const [schedularDate, setSchedularDate] = useState({});
   
     const receiveDataFromSchedularModal = ({ newSchedular }) => {
       setUseEffectCall(true);
       setSchedularDate(newSchedular);
     };
   
     useEffect(() => {
         if (useEffectCall) {
           requestData.storeIds = [storeValue]
           requestData.startDate = schedularDate?.startDate
             ? localeDateStartDate(new Date(schedularDate.startDate))
             : localeDateStartDate(new Date(startDate));
           requestData.endDate = schedularDate?.endDate
             ? localeDateEndDate(new Date(schedularDate.endDate))
             : localeDateEndDate(new Date(endDate));
   
           fetchStoreIncomeExpense(requestData);
         }
       }, [schedularDate]);

  const [searchTerm, setSearchTerm] = useState("");

  const [expandedIncomeServices, setExpandedIncomeServices] = useState({});
  const [expandedExpenseServices, setExpandedExpenseServices] = useState({});

  // const toggleService = (service) => {
  //   setExpandedServices((prev) => ({
  //     ...prev,
  //     [service]: !prev[service],
  //   }));
  // };

  const toggleServiceIncome = (service) => {
    setExpandedIncomeServices((prev) => {
      // If the same service is already open, close all
      if (prev[service]) {
        return {};
      }
      // Otherwise, close all and open only the clicked service
      return { [service]: true };
    });
  };

  const toggleServiceExpense = (service) => {
    setExpandedExpenseServices((prev) => {
      // If the same service is already open, close all
      if (prev[service]) {
        return {};
      }
      // Otherwise, close all and open only the clicked service
      return { [service]: true };
    });
  };

  const filterIncomeData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();
    let filteredData = {};

    Object.keys(data).forEach((category) => {
      const filteredList = data[category].list.filter((item) =>
        Object.values(item).some((value) =>
          typeof value === "string" || typeof value === "number"
            ? value.toString().toLowerCase().includes(searchLower)
            : false
        )
      );

      if (filteredList.length > 0) {
        filteredData[category] = {
          ...data[category],
          list: filteredList,
          totalAmount: filteredList.reduce((sum, item) => sum + item.amount, 0), // Recalculate total amount
        };
      }
    });

    return filteredData;
  };

  const filteredIncomeData = filterIncomeData(storeIncomeData, searchTerm);

  const filterExpenseData = (data, searchTerm) => {
    if (!searchTerm) return data; // Return full data if search is empty

    const searchLower = searchTerm.toLowerCase();
    let filteredData = {};

    Object.keys(data).forEach((category) => {
      const filteredList = data[category].list.filter((item) =>
        Object.values(item).some((value) =>
          typeof value === "string" || typeof value === "number"
            ? value.toString().toLowerCase().includes(searchLower)
            : false
        )
      );

      if (filteredList.length > 0) {
        filteredData[category] = {
          ...data[category],
          list: filteredList,
          totalAmount: filteredList.reduce((sum, item) => sum + item.amount, 0), // Recalculate total amount
        };
      }
    });

    return filteredData;
  };

  const filteredExpenseData = filterExpenseData(storeExpenseData, searchTerm);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      const userName = item.userName;
      return (
        <div>
          <div className="flex-1 ">
            <div className="mx-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 0.5,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Amount :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {storeLocalData?.currencySymbol} {item.amount}
                  </p>
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 0.7,
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Date :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formatDateNewWithTime(item.createdDate)}
                  </p>
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 1,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{userName}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Remark
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.remark}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() => {
                      setStoreIncomeExpenseCreateModalVisible(true);
                      setSelectedUserItemValue(item);
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Cashbook")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                INCOME/ EXPENSE
              </p>
            </div>
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center mx-4 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="w-full ">
        <div className="mx-4 mt-2">
          <Dropdown
            value={storeValue}
            onChange={(e) => handleStoreChange(e.value)}
            options={storeList}
            placeholder="Select Store"
            optionLabel="name"
            className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
          />
        </div>
      </div>
      {storeValue !== "" ? (
        <div>
          <div className="my-2 mx-5 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={`Search Income/ Expense`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm && (
              <div
                className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                onClick={handleClearSearch}
              >
                <div>
                  <p className="text-4xl font-bold " style={{ color: "red" }}>
                    X
                  </p>
                </div>
              </div>
            )}
            <div
              className="flex justify-content-between align-items-center border-round-lg mx-2 px-2"
              style={{
                color: "#fff",
                backgroundColor: "green",
                borderColor: "green",
              }}
            >
              <div>
                <p className="text-xl font-medium " style={{ color: "#fff" }}>
                  Available Cash Balance : {storeLocalData?.currencySymbol} {cashbookBalanceData}
                </p>
              </div>
            </div>
          </div>
          <div>
            {loading ? (
              <div style={{ flex: 1 }}>
                <div className="text-center">
                  <ProgressSpinner
                    style={{ width: "70px", height: "70px" }}
                    strokeWidth="4"
                    fill="var(--surface-ground)"
                    animationDuration="2s"
                  />
                </div>
              </div>
            ) : (
              <div className="flex flex-1 justify-content-between">
                <div className="flex-1">
                  <div>
                    <div
                      className="flex-1  surface-0"
                      style={{ "--surface-0": "#EAEFF5" }}
                    >
                      <div className="flex justify-content-between mx-4">
                        <div className="py-1">
                          <p className=" text-2xl  font-bold ">INCOME</p>
                        </div>
                      </div>
                    </div>
                    {Object.keys(filteredIncomeData).length > 0 ? (
                      Object.keys(filteredIncomeData).map((service) => (
                        <div key={service}>
                          <div className="mx-4 my-2">
                            <div className="flex cursor-pointer">
                              <div
                                className="w-full flex justify-content-between border-round-lg p-1 cursor-pointer"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "green",
                                  borderColor: "green",
                                }}
                                onClick={() => toggleServiceIncome(service)}
                              >
                                <p className="text-lg font-semibold px-2">
                                  {service}
                                </p>
                                <div className="flex">
                                  <p className="text-lg font-semibold px-2">
                                    Total : {storeLocalData?.currencySymbol}{" "}
                                    {filteredIncomeData[service].totalAmount}
                                  </p>
                                  <i
                                    className={
                                      !expandedIncomeServices[service]
                                        ? "pi pi-angle-down"
                                        : "pi pi-angle-up"
                                    }
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#fff",
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          {expandedIncomeServices[service] && (
                            <div
                              className="scroll-bar my-2 py-2"
                              style={{
                                overflowY: "auto", // shows scrollbar only when needed
                                maxHeight: "20rem", // limits height to 15rem, then scrolls
                              }}
                            >
                              {renderCardItem(filteredIncomeData[service].list)}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="my-4 flex justify-content-center">
                        <p className="text-xl font-medium">No Income Found</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex-1">
                  <div>
                    <div
                      className="flex-1  surface-0"
                      style={{ "--surface-0": "#EAEFF5" }}
                    >
                      <div className="flex justify-content-between mx-4">
                        <div className="py-1">
                          <p className=" text-2xl  font-bold ">EXPENSE</p>
                        </div>
                      </div>
                    </div>
                    {Object.keys(filteredExpenseData).length > 0 ? (
                      Object.keys(filteredExpenseData).map((service) => (
                        <div>
                          <div className="mx-4 my-2">
                            <div className="flex cursor-pointer">
                              <div
                                className="w-full flex justify-content-between border-round-lg p-1 cursor-pointer"
                                style={{
                                  color: "#fff",
                                  backgroundColor: "red",
                                  borderColor: "red",
                                }}
                                onClick={() => toggleServiceExpense(service)}
                              >
                                <p className="text-lg font-semibold px-2">
                                  {service}
                                </p>
                                <div className="flex">
                                  <p className="text-lg font-semibold px-2">
                                    Total : {storeLocalData?.currencySymbol}{" "}
                                    {filteredExpenseData[service].totalAmount}
                                  </p>
                                  <i
                                    className={
                                      !expandedExpenseServices[service]
                                        ? "pi pi-angle-down"
                                        : "pi pi-angle-up"
                                    }
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#fff",
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          {expandedExpenseServices[service] && (
                            <div
                              className="scroll-bar my-2 py-2"
                              style={{
                                overflowY: "auto", // shows scrollbar only when needed
                                maxHeight: "20rem", // limits height to 15rem, then scrolls
                              }}
                            >
                              {renderCardItem(
                                filteredExpenseData[service].list
                              )}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="my-4 flex justify-content-center">
                        <p className="text-xl font-medium">No Expense Found</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-content-center mt-4">
          <p className="text-2xl font-semibold">
            Please Select Store to get Income/ Expenses
          </p>
        </div>
      )}


      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
      <StoreIncomeExpenseCreateModalAdmin
        setStoreIncomeExpenseCreateModalVisible={
          setStoreIncomeExpenseCreateModalVisible
        }
        storeIncomeExpenseCreateModalVisible={
          storeIncomeExpenseCreateModalVisible
        }
        sendDataToUserList={receiveDataFromStoreIncomeExpenseCreateModal}
        brandId={brandId}
        storeId={storeValue}
        storeUserId={storeUserId}
        selectedUserItemValue={selectedUserItemValue}
        cashbookBalance={cashbookBalanceData}
        brandCreatedDate={brandProfileData.createdDate}
      />
    </div>
  );
};

export default StoreWiseIncomeExpense;
